/**
 * Build info — single source of truth for the app version.
 *
 * Values are injected at build time by vite.config.ts (`define`). The UI shows only major.minor
 * (VERSION); the full version + git SHA + build time (BUILD) are logged to the console on load so
 * you can confirm exactly which build is live without cluttering the chrome.
 */
export const FULL_VERSION = __APP_VERSION__;                       // e.g. "2.0.0"
export const VERSION = __APP_VERSION__.split(".").slice(0, 2).join("."); // major.minor, e.g. "2.0"
export const BUILD = {
  version: __APP_VERSION__,
  sha: __BUILD_SHA__,
  builtAt: __BUILD_TIME__,
};

/** One-line build banner for the console (called once on app load). */
export function logBuildInfo(): void {
  console.info(`Cortex v${BUILD.version} · ${BUILD.sha} · ${BUILD.builtAt}`);
}
